import { useFormikContext } from 'formik';

import type { FormInstance } from './types';

export const useForm = <T extends {}>(): FormInstance<T> => {
  return useFormikContext<T>();
};
